<template>
    <div class="tree-property-grid grid grid-cols-3 gap-8 mb-8">
        <slot />
    </div>
</template>
